import { useScrollAnimation } from '../hooks/useScrollAnimation'

export default function CTABanner({ headline, subtext, ctaText, ctaHref = '/register', microcopy }) {
  const ref = useScrollAnimation()

  return (
    <section className="bg-[#F0FDF4] section-padding border-t border-[#DCFCE7]">
      <div ref={ref} className="content-narrow text-center">
        <h2 className="font-display text-4xl lg:text-5xl text-[#0F172A] leading-tight">
          {headline}
        </h2>
        <p className="mt-4 text-lg text-[#475569] max-w-xl mx-auto">
          {subtext}
        </p>
        <a
          href={ctaHref}
          className="inline-block mt-8 bg-[#1B5E20] text-white font-medium text-base px-9 py-4 rounded-full hover:bg-[#145218] hover:shadow-gold-glow hover:-translate-y-px transition-all duration-400"
        >
          {ctaText}
        </a>
        {microcopy && (
          <p className="mt-4 text-xs text-[#94A3B8] tracking-wide uppercase">
            {microcopy}
          </p>
        )}
      </div>
    </section>
  )
}
